// numberInputGuard.ts — 휠 스크롤로 숫자 입력값이 바뀌는 사고를 막는 전역 가드.
//
// 브라우저는 포커스된 <input type="number"> 위에서 휠을 굴리면 값을 증감시킨다.
// globals.css 에서 스피너를 지운 것과는 무관한 기본 동작이라 CSS 로는 막히지 않고,
// 견적 화면에서 표를 스크롤하다 C/T·임율·여유율이 조용히 바뀐 채 저장되는 사고로 이어진다.
//
// 입력이 화면마다 흩어져 있어도 휠 이벤트는 전부 document 를 지나가므로,
// 여기서 한 번만 막는다 — 새 화면이 숫자 입력을 추가해도 따로 챙길 게 없다.
// 커서가 그 입력 위에 있을 때만 값이 바뀌므로, 조건도 "포커스된 입력 위의 휠"로 좁힌다.
// (페이지 다른 곳을 스크롤할 때는 포커스를 유지한다.)
//
// passive: true — 스크롤 자체는 막지 않는다. 포커스만 놓으면 값은 그대로 두고
// 페이지는 정상적으로 스크롤된다. 입력값은 keystroke 마다 이미 onChange 로
// 상위 state 에 반영되므로 blur 로 유실되는 값은 없다.
export function initNumberInputGuard(): () => void {
  const onWheel = (e: WheelEvent) => {
    const el = document.activeElement;
    if (el instanceof HTMLInputElement && el.type === "number" && e.target === el) {
      el.blur();
    }
  };
  document.addEventListener("wheel", onWheel, { passive: true });
  return () => document.removeEventListener("wheel", onWheel);
}
